



























































































import { Component, Vue } from "vue-property-decorator";
import {
  TeamOverviewTimeValidationAppUserDayModel,
  TeamOverviewTimeValidationModel
} from "@/services/api/nswag/stapiclient_generated";
import { stTeamOverviewApi } from "@/services/st-api";
import { DateTime } from "luxon";
import StBadge from "@/components/basic/StBadge.vue";
import UserSelect from "@/views/TimeEntries/UserSelect.vue";
import TimeAccountDayCell from "@/views/TimeAccount/TimeAccountDayCell.vue";
import TimeAccountSumCell from "@/views/TimeAccount/TimeAccountSumCell.vue";
import { notifySuccess } from "@/utlitities/notifications";
//@ts-ignore
import * as FileSaver from "file-saver";
import { UserStore } from "@/store/user-module";
import { getHours } from "@/utlitities/helper";

@Component({
  components: {
    TimeAccountSumCell,
    TimeAccountDayCell,
    UserSelect,
    StBadge
  }
})
export default class TeamOverview extends Vue {
  year: number = this.currentDate.year;
  loading = true;
  delayLoading = false;
  emailLoading = false;
  model: TeamOverviewTimeValidationModel = TeamOverviewTimeValidationModel.fromJS({});

  get currentDate() {
    return UserStore.userNowDateTime;
  }

  get currentYear() {
    return this.currentDate.year;
  }

  get useNightWorkReport(): boolean {
    return UserStore.userSettings.featureFlagNightWorkReport;
  }

  getDayCssClass(day: TeamOverviewTimeValidationAppUserDayModel) {
    if (!day.appUserDay) {
      return "bg-striped-gray";
    }

    const appUserDay = day!.appUserDay!;

    if (!appUserDay.dayDescription!.isWorkDay) {
      if (appUserDay.dayDescription?.badgeText) {
        return "bg-blue-500 text-white";
      }
      return "bg-gray-300";
    }

    if (appUserDay.targetMinutesEffective! > 0) {
      if (appUserDay.effectiveTargetMinutesEnteredPercentage! >= 75) {
        return "bg-green-500";
      }

      if (appUserDay.effectiveTargetMinutesEnteredPercentage! < 75 && appUserDay.durationMinutes! > 0) {
        return "bg-yellow-500 text-white";
      }

      if (appUserDay.durationMinutes! == 0) {
        return "bg-red-400 text-white";
      }
    } else {
      if (appUserDay.durationMinutes! > 0) {
        return "bg-green-500";
      }
    }

    return "bg-gray-100";
  }

  getDayTooltip(day: TeamOverviewTimeValidationAppUserDayModel) {


    const soll = "<div class=\"whitespace-nowrap mr-4\">Soll:</div><div>" + getHours(day.appUserDay?.targetMinutes) + " h</div>";
    const ist = "<div class=\"whitespace-nowrap mr-4\">Ist:</div><div>" + getHours(day.appUserDay?.durationMinutes) + " h</div>";


    if (!day.appUserDay) {
      if (DateTime.fromISO(day.date) <= this.currentDate) {
        return { content: "Keine Daten" };
      }
      return { content: "Zukunft" };
    }

    const appUserDay = day!.appUserDay!;

    if (!appUserDay.dayDescription!.isWorkDay) {
      if (appUserDay.dayDescription?.description) {
        return { content: appUserDay.dayDescription.description };
      }
      return { content: "Kein Arbeitstag" };
    }

    if (appUserDay.targetMinutesEffective! > 0) {
      if (appUserDay.effectiveTargetMinutesEnteredPercentage! >= 75) {
        return {
          content: `<div class="grid grid-cols-2"><div class="col-span-2">OK</div>${soll}${ist}</div>`,
          isHtml: true
        };
      }

      if (appUserDay.effectiveTargetMinutesEnteredPercentage! < 75 && appUserDay.durationMinutes! > 0) {
        return { content: `<div class="grid grid-cols-2"><div class="col-span-2">Weniger als 75% der Sollstunden erfasst</div>${soll}${ist}</div>` };
      }

      if (appUserDay.durationMinutes! == 0) {
        return { content: `<div class="grid grid-cols-2"><div class="col-span-2">Keine Zeiteinträge</div>${soll}${ist}</div>` };
      }
    } else {
      if (appUserDay.durationMinutes! > 0) {
        return { content: "Ok" };
      }
    }

    return { content: "" };
  }

  async changeYear(plusminus: number) {
    try {
      this.loading = true;
      this.year += plusminus;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    try {
      this.loading = true;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async loadData() {
    this.model = await stTeamOverviewApi.getTimeEntryStats(this.year);
  }

  async exportExcelMonth(year: number, month: number) {
    try {
      let result = await stTeamOverviewApi.downloadMonthData(year, month);
      FileSaver.saveAs(result.data, `SpikeTime_Export_${year}_${month}.xlsx`);
    } finally {
    }
  }

  async exportExcelYear(year: number) {
    try {
      let result = await stTeamOverviewApi.downloadYearData(year);
      FileSaver.saveAs(result.data, `SpikeTime_Export_${year}.xlsx`);
    } finally {
    }
  }

  async exportExcelNightHours(year: number, month: number) {
    try {
      let result = await stTeamOverviewApi.downloadNightWorkData(year, month);
      FileSaver.saveAs(result.data, `SpikeTime_Nachtarbeit_${year}_${month}.xlsx`);
    } finally {
    }
  }

  async sendReminderEmail() {
    try {
      this.emailLoading = true;
      await stTeamOverviewApi.sendTimeEntrySummaryMail();
      notifySuccess("Erinnerung versendet");
      await this.loadData();
    } finally {
      this.emailLoading = false;
    }
  }
}
